import { render } from "./VehicleTripsTabular.vue?vue&type=template&id=33e2e83c"
import script from "./VehicleTripsTabular.vue?vue&type=script&lang=js"
export * from "./VehicleTripsTabular.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__